// 主にIE11用のプログラムコード。
// 読み込ませないとプログラムがIE11で動かない

export default function() {
  if (typeof Object.assign != 'function') {
    Object.assign = function (target) {
      'use strict';
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      target = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var source = arguments[index];
        if (source != null) {
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
      }
      return target;
    };
  }

  // if (typeof Array.prototype.forEach != 'function') {
  //   Array.prototype.forEach = function (callback) {
  //     for (var i = 0; i < this.length; i++) {
  //       callback.apply(this, [this[i], i, this]);
  //     }
  //   };
  // }

  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  /**
 * IE11で「Number.isNaN」を使用できるようにする
 */
  Number.isNaN = Number.isNaN || function (any) {
    return typeof any === 'number' && isNaN(any);
  };

  /**
 * IE11でrepeat()メソッドを使用できるようにする
 *
 * @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
 */
  // if (!String.prototype.repeat) {
  //   String.prototype.repeat = function(count) {
  //     'use strict';
  //     if (this == null)
  //       throw new TypeError('can\'t convert ' + this + ' to object');

  //     var str = '' + this;
  //     // To convert string to integer.
  //     count = +count;
  //     // Check NaN
  //     if (count != count)
  //       count = 0;

  //     if (count < 0)
  //       throw new RangeError('repeat count must be non-negative');

  //     if (count == Infinity)
  //       throw new RangeError('repeat count must be less than infinity');

  //     count = Math.floor(count);
  //     if (str.length == 0 || count == 0)
  //       return '';

  //     // Ensuring count is a 31-bit integer allows us to heavily optimize the
  //     // main part. But anyway, most current (August 2014) browsers can't handle
  //     // strings 1 << 28 chars or longer, so:
  //     if (str.length * count >= 1 << 28)
  //       throw new RangeError('repeat count must not overflow maximum string size');

  //     var maxCount = str.length * count;
  //     count = Math.floor(Math.log(count) / Math.log(2));
  //     while (count) {
  //       str += str;
  //       count--;
  //     }
  //     str += str.substring(0, maxCount - str.length);
  //     return str;
  //   };
  // }

}
